import React, { useContext, useEffect } from 'react'
import MobileConfirmAppointmentForm from './Mobile/MobileConfirmAppointmentForm'
import ComputerConfirmAppointmentForm from './Computer/ComputerConfirmAppointmentForm'
import TabletConfirmAppointmentForm from './Tablet/TabletConfirmAppointmentForm'
import { screenSize } from '../../Common/Common'
import PublicContext from '../PublicContext'
import { useNavigate } from 'react-router'
import { post } from '../../Common/api'
import { t } from 'i18next'
import { notification } from 'antd'

export default function ConfirmAppointmentForm () {
  const { data, appointment, setLoading, setSiderTitle, updateStatus } = useContext(PublicContext)
  const navigate = useNavigate()

  const onFinish = (values) => {
    setLoading(true)
    post({
      url: `public/appointments/${appointment.id}/confirm`,
      params: values,
      onSuccess: (res) => {
        setLoading(false)
        updateStatus(res)
        navigate(`/appointments/${appointment.id}`)
      },
      onFailure: (response) => {
        let message = t('Public.ConfirmAppointmentForm.error')
        if (Object.keys(response.errors).length !== 0) {
          message = Object.keys(response.errors).map(key => (response.errors[key]))
        }
        notification.error({ message, placement: 'bottom' })
        setLoading(false)
      }
    })
  }

  const onFinishFailed = () => {
    setLoading(false)
  }

  const resendCode = () => {
    post({
      url: `public/appointments/${appointment.id}/resend_confirmation_code`,
      params: {},
      onSuccess: () => {
        notification.success({ message: t('Public.ConfirmAppointmentForm.resendSuccess'), placement: 'bottom' })
      }
    })
  }

  const initialValues = {
    start_timestamp: data?.appointmentTime?.start,
    end_timestamp: data?.appointmentTime?.end,
    calendar_id: data?.calendarId,
    country: data?.country,
    civility: data?.civility,
    reason_id: data?.reasonId
  }

  useEffect(() => {
    setSiderTitle(t('Public.ConfirmAppointmentPage.title'))
  }, [])

  const appointmentForm = {
    Mobile: MobileConfirmAppointmentForm,
    Computer: ComputerConfirmAppointmentForm,
    Tablet: TabletConfirmAppointmentForm
  }

  const ResponsiveForm = appointmentForm[screenSize()]

  return (
    <ResponsiveForm initialValues={initialValues} resendCode={resendCode} onFinishFailed={onFinishFailed} onFinish={onFinish} />
  )
}
